// extracted by mini-css-extract-plugin
export var footer = "_pr-5";
export var fulfillmentInput = "_pr-0";
export var shipDateInput = "_pr-1";
export var shipmentModal = "_pr-2";
export var shipmentModalContent = "_pr-3";
export var tableContainer = "_pr-4";